import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { ResultFileState } from './ConfigFormData';
import { Operations } from './NavigatorData';

export interface ProgressIndicatorProps {
  percentage: number;
  //TO DO : Remove operation and resultFileState once XML Merge reports the percentage
  operation: Operations;
  resultFileState: ResultFileState;
}

export function ProgressIndicator(props: ProgressIndicatorProps) {
  const { percentage, operation, resultFileState } = props;
  if (percentage === 0 || percentage === 100 || resultFileState !== ResultFileState.inProgress) {
    return (<Grid item style={{ width: '10%', float: 'right', margin:'0px', height:'40px'}}></Grid>);
  } else {
    return (<Grid item style={{ width: '10%', float: 'right', margin:'0px', height:'40px'}}>
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="indeterminate" value={percentage} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {operation !== Operations.threeWayMerge && operation !== Operations.graft && (
            <Typography variant="body2" color="primary">{(percentage === undefined) ? 1 : percentage}%</Typography>
          )}
        </Box>
      </Box>
    </Grid>);
  }
}

export default ProgressIndicator;